import React from 'react'

import { digObject } from '@domain-group/javascript-utils'
import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

import useCurrentUser from '@hooks/useCurrentUser'

interface BrandDataProps {
  brandFormPayload: UseFormPayload,
}

const BrandData = (props: BrandDataProps) => {
  const { brandFormPayload } = props || {}
  const {
    entityState: {
      data,
      salesforce_id,
    },
    handlers,
  } = brandFormPayload

  const realbaseId = digObject(data, 'external_ids.realbase')

  const { isMasterAdmin } = useCurrentUser()

  return (
    <DashboardModule title="Data">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Realbase ID">
            <input
              disabled={!isMasterAdmin}
              name="data.external_ids.realbase"
              type="number"
              value={realbaseId}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Salesforce ID" marginTop={['large', 0]}>
            <input
              disabled={!isMasterAdmin}
              name="salesforce_id"
              type="text"
              value={salesforce_id}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default BrandData
